module.exports = __webpack_public_path__ + "img/hohlschnitt_steingrau_ohneral.d1449a00.jpg";